<div class="row">
  <div class="col-md-12">
    <uni-alert>
      <uni-alert-title> ¡Usuario {{ isEditing ? "editado" : "creado" }} exitosamente! </uni-alert-title>
      <h6 *ngIf="!isEditing" uni-heading color="lighten" class="darkgray-text">
        Hemos enviado un mensaje de activación al correo electrónico {{ newUser?.email }}
      </h6>
      <h6 *ngIf="isEditing" uni-heading color="lighten" class="darkgray-text">Los datos del usuario han sido actualizados</h6>
    </uni-alert>
  </div>

  <div class="col-12 mb-4" data-testid="creation-summary">
    <uni-summary *ngIf="newUser">
      <uni-summary-header color="gray" alignment="block">
        <uni-summary-section name="Nombre(s)" [description]="newUser?.name"></uni-summary-section>
        <uni-summary-section name="Apellido(s)" [description]="newUser?.lastName"></uni-summary-section>
      </uni-summary-header>
      <uni-summary-group heading="Datos Personales del Usuario">
        <uni-summary-section
          [name]="newUser?.identificationType | identificationType | async"
          [description]="newUser?.identification"
        ></uni-summary-section>
        <uni-summary-section name="Teléfono" [description]="newUser?.telephone | mask : '(000) 000-0000'"></uni-summary-section>
        <uni-summary-section name="Fecha de Cumpleaños" [description]="newUser?.birthDate | date : 'dd/MM'"></uni-summary-section>
        <uni-summary-section name="Provincia" [description]="newUser?.province?.nombre"></uni-summary-section>
      </uni-summary-group>

      <uni-summary-group heading="Datos de Acceso">
        <uni-summary-section name="Empresa" [description]="newUser?.company"></uni-summary-section>
        <uni-summary-section name="Código de Usuario" [description]="newUser?.userCode"></uni-summary-section>
        <uni-summary-section name="Identificación Perfil" [description]="newUser?.identificationProfile"></uni-summary-section>
        <uni-summary-section
          *ngIf="newUser?.clientCode"
          name="Código de Cliente"
          [description]="newUser?.clientCode"
        ></uni-summary-section>
        <uni-summary-section
          *ngIf="newUser?.intermediaryCode"
          name="Código de Intermediario"
          [description]="newUser?.intermediaryCode"
        ></uni-summary-section>
        <uni-summary-section
          *ngIf="newUser?.healthProviderCode"
          name="Código de Prestador"
          [description]="newUser?.healthProviderCode"
        ></uni-summary-section>
        <uni-summary-section *ngIf="newUser?.officeCode" name="Código de Sucursal" [description]="newUser?.officeCode">
        </uni-summary-section>
        <uni-summary-section name="Correo Electrónico" [description]="newUser?.email"></uni-summary-section>
        <uni-summary-section name="Perfil" [description]="newUser?.profile?.nombre"></uni-summary-section>
        <uni-summary-section name="Roles" [description]="roles"> </uni-summary-section>
      </uni-summary-group>

      <uni-summary-group heading="Fideicomisos">
                
        <uni-summary-section 
          *ngFor="let fideicomiso of escrows"
          [name]="fideicomiso.sNombreCorto"
          [description]="getDependencias(fideicomiso.dependencies)">
        </uni-summary-section> 
      </uni-summary-group>
    </uni-summary>
  </div>

  <div class="col-md-12 text-right">
    <a 
      [routerLink]="isOperative ? ['/portales/fiduciaria/fiduciary-manage-users/operational'] : ['/portales/fiduciaria/fiduciary-manage-users']" 
      class="mr-2 btn bt-info"
    >Regresar</a>
    <button 
      [routerLink]="isOperative ? ['/portales/fiduciaria/fiduciary-manage-users/operational'] : ['/portales/fiduciaria/fiduciary-manage-users']" 
      (click)="reset.emit()" 
      uni-button icon="chevron-right"
    >Nuevo Usuario</button>
  </div>
</div>
